export default __webpack_public_path__ + "static/media/icon-instagram.df587328.svg";